
    var riot = require('riot')
    riot.tag2('gb-product-image', '<a class="gb-product-image" href="{$product.link()}"> <gb-lazy-image if="{$productable.lazy}" riot-src="{$product.imageLink()}"></gb-lazy-image> <img if="{!$productable.lazy}" riot-src="{$product.imageLink()}" alt=""> </a>', '', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/product/gb-product-image.tag.html